<template>
    <div class="vm-feed-action fwn flex-box flex-center pointer" :class="[browser_size]" @click.self="tab" v-click-outside="close_more">
            <i class="afd afd-diandiandian fs12" @click.self="tab"></i>
            <div v-show="is_show_more" class="select-time-box">
              <a class="item-box black-8 nowrap flex-box flex-align-items-center fs14" @click="draft_submit">
                <i class="afd afd-draft mr8"></i>
                <span>{{$t('c.FeedAction.text1')}}</span>
              </a>
              <a v-if="!post.post_id" class="item-box black-8 nowrap flex-box flex-align-items-center fs14" @click="show_timing">
                  <i class="afd afd-clock mr8"></i>
                  <span>{{$t('c.FeedAction.text2')}}</span>
              </a>
            </div>
        </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    name: 'feedAction',
    props: {
        post: {
            default(){
              return {}
            }
        }
    },
    data() {
        return {
            is_show_more:false,
            is_show_timing:true,
        };
    },
    computed:{
        ...mapState('app', ['session_user', 'browser_size']),
    },
    mounted() {
    },
    methods: {
        tab(){
            this.is_show_more = !this.is_show_more;
        },
        close_more(){
            this.is_show_more = false;
        },
        show_timing(){
            this.$store.dispatch('app/set:is_show_timing', true);
            this.close_more();
            // this.open_date();
        },
        draft_submit(){
            this.$emit('draft_submit')
        },
    }
};
</script>

<style lang="stylus" scoped>
.vm-feed-action{
    width:26px;
    height:26px;
    position: relative;
    border-radius:100%;
    background:$white-bg;
    .afd-diandiandian{
        position: absolute;
        left:50%;
        top:50%;
        transform: translate(-50%, -50%);
    }
    .select-time-box{
        border: 1px solid $black-1;
        box-sizing: border-box;
        box-shadow: $layer-shadow;
        position: absolute;
        bottom: 0px;
        right: 0;
        background:$white;
        width:200px;
        transform: translateY(105%);
        border-radius: 4px;
        z-index: 1;
        .item-box{
            padding:12px 16px;
            &:active{
                background:$black-05;
            }
        }
    }
    .afd-draft,
    .afd-clock{
        width:14px;
        height:14px;
    }
    &.small{
        .afd-draft,
        .afd-clock{
            position :relative;
            top:-2px;
        }
    }
  }
</style>
